module.exports = __webpack_public_path__ + "static/media/caro_img_4.4cbc6dd3.webp";